<template>
  <div class="vh-100 d-flex position-relative">
    <div class="row w-100">
      <div class="col-md-7 d-none d-md-block">
        <img src="https://storage.googleapis.com/smart-force-goa-logos/test_client_background.jpg" alt="Login Image" class="img-fluid" 
          style="object-fit: cover; min-height: 100vh;"  />
      </div>

      <div class="col-md-5 position-absolute p-3 d-flex flex-column h-100" style="right: 0;">
        <div class="text-center mb-4 mt-3">
          <img src="/assets/images/test-logo.png" alt="Logo" style="height: 80px; width: 80px;" />
          <div class="fw-bold fs-6 mt-1">Test Client</div>
        </div>

        <form @submit.prevent="handleLogin" class="d-flex flex-column align-items-center flex-grow-1">
          <!-- Personal Message Field -->
          <div class="mb-3">
            <label for="message" class="form-label">
              Enter Personal Message <span class="text-danger">*</span>
            </label>
            <textarea id="message" v-model="message" class="form-control overflow-auto"
              style="width: 340px; max-height: 90px;" placeholder="Enter personal message" :disabled="showloader"
              :class="{ 'is-invalid': v$.message.$error }"></textarea>
            <div v-if="v$.message.$error" class="text-danger error-message">
              This Personal Message is required.
            </div>
            <div>
              <div class="text-danger error-message mt-2" v-if="messageError">
                {{ messageError }}
              </div>
            </div>
          </div>

          <!-- CAPTCHA Field -->
          <div class="mb-3">
            <VueRecaptcha sitekey="6LeV0kwrAAAAADw83dxC50fV0s_gvHn-OriKOGME" @verify="handleCaptcha"
              @expired="resetCaptcha" class="d-flex justify-content-center" />
            <div class="text-danger error-message mt-2" v-if="captchaStatus === 0 && captchaError">
              {{ captchaError }}
            </div>
          </div>
          <button type="submit" class="btn btn-primary mt-2 mb-4 d-flex justify-content-center align-items-center"
            style="width: 340px;" :disabled="showloader || success">
            <span v-if="!showloader" class="login">Submit</span>
            <div class="spinner-border text-light custom-spinner-loader-btn" role="status" v-if="showloader"
              style="width: 1.5rem; height: 1.5rem;"></div>
          </button>
        </form>

        <!-- Bottom Aligned Images -->
        <div class="d-flex justify-content-between" style="bottom: 10px;">
          <div class="mb-2 mt-2 flex-grow-1">
            <img src="/assets/images/Smart-force.png" alt="Party Logo" style="height: 90px; width: auto;" />
          </div>
          <div class="mb-2 mt-2">
            <img src="/assets/images/samruddh-logo.png" alt="Party Logo" style="height: 90px; width: auto;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { VueRecaptcha } from "vue-recaptcha";
import ApiService from '../service/ApiService';
import { useToast } from 'vue-toast-notification';

const toast = useToast();
const messageError = ref('');
const message = ref('');
const apiService = new ApiService();
const captchaStatus = ref(0); // To track CAPTCHA status
const captchaError = ref('');
const showloader = ref(false);
const reCapcha = ref('');
const recaptchaRef = ref(null);
const success = ref(false);
// const router = useRouter();

// Validation rules
const rules = {
  message: { required },
};

// Initialize Vuelidate
const v$ = useVuelidate(rules, { message });

// Handle CAPTCHA verification
const handleCaptcha = (response) => {
  if (response) {
    reCapcha.value = response;
    captchaStatus.value = 1; // CAPTCHA verified
    captchaError.value = ''; // Clear the error
  } else {
    captchaStatus.value = 0; // CAPTCHA failed
    captchaError.value = 'CAPTCHA verification failed!';
  }
};

// Reset CAPTCHA
const resetCaptcha = () => {
  captchaStatus.value = 0; // Reset status
  captchaError.value = 'CAPTCHA expired. Please try again.';
};

// Form submission handler
const handleLogin = async () => {
  v$.value.$touch(); // Mark fields as touched
  if (!v$.value.$invalid && captchaStatus.value === 1) {
    showloader.value = true;
    try {
      const response = await apiService.getLoginDetail({ secret_message: message.value,  g_recaptcha_response: reCapcha.value });
      if (response.status == 200) {
        localStorage.setItem('login-key', response.ah14);
        let sharedId = response.ah14;
        let targetUrl = `${response.url}?shared_id=${sharedId}`;
        messageError.value = '';
        if (!/^https?:\/\//i.test(targetUrl)) {
          targetUrl = 'https://' + targetUrl; // Add https if missing
        }
        success.value = true;
        window.open(targetUrl, '_blank');
      } else if (response.status == 403) {
        captchaError.value = response.message;
        captchaStatus.value = 0;
        recaptchaRef.value.reset();
      } else {
        messageError.value = response.message;
        toast.open({
          message: response.message,
          type: "error",
          duration: 3000,
          position: "top-right",
        });
      }
      showloader.value = false;
    } catch (error) {
      showloader.value = false;
      console.log(error);
    }

  } else if (captchaStatus.value === 0) {
    captchaError.value = 'Please complete the CAPTCHA!';
  }
};

const getUserDetails = async() => {
  try {
    const response = await apiService.getUserDetails();
    if (response.status == 200) {
      message.value = "";
    }
  } catch (error) {
    console.log(error);
  }
}

onMounted(() => {
  getUserDetails();
});
</script>

<style scoped>
textarea::placeholder,
input::placeholder {
  font-size: 0.875rem;
  /* Smaller font size for placeholder */
  color: #6c757d;
  /* Optional: Change placeholder color */
}

.is-invalid {
  border-color: #dc3545;
}

.error-message {
  font-size: 0.875rem;
  /* Equivalent to small */
  margin-top: 0.25rem;
}
</style>
